import Vue from "vue";
import App from "./App.vue";

export default function init() {
  function createGoogleMap(element) {
    new Vue({
      render: createElement => {
        const context = {
          props: { ...element.dataset }
        };
        return createElement(App, context);
      }
    }).$mount(`#${element.id}`);
  }

  const maps = document.querySelectorAll(".googleMaps");
  if (maps) {
    Vue.config.productionTip = false;

    maps.forEach(map => {
      if (map.classList.contains("googleMapsInTab")) {
        return;
      }

      createGoogleMap(map);
    });
  }

  window.initGoogleMapsInContentTabs = () => {
    const containers = document.querySelectorAll(".ContentTabs__container");

    containers.forEach(container => {
      const maps = container.querySelectorAll(".googleMaps");

      maps.forEach(map => {
        const modifiedId = `${map.id}-in-tab`;
        map.id = modifiedId;
        createGoogleMap(map);
      });
    });
  };
}
